import { styled } from "goober";
import { useRef, useState } from "react";
import { writeToClipboard } from "../lib/writeToClipboard";
import { ClickButton } from "./ClickButton";
import { AnimatedCopyIcon } from "./AnimatedCopyIcon";

const Button = styled(ClickButton)`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  opacity: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  box-shadow: var(--elevation-low);
  color: var(--text-primary);
  &:hover {
    background: var(--surface-hover);
  }
`;

export function CopyButton({
  getText,
}: {
  getText: () => string | null | undefined;
}) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  return (
    <Button
      data-copy-button
      onClick={() => {
        const text = getText();
        if (text) void writeToClipboard(text);
        setCopied(true);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setCopied(false), 1500);
      }}
    >
      <AnimatedCopyIcon copied={copied} />
    </Button>
  );
}
